import poweredByStrava from '../assets/strava/api_logo_pwrdBy_strava_horiz_orange.svg';
import styles from './PoweredByStrava.module.css';

// Strava's own "Powered by Strava" file (developers.strava.com/guidelines), unmodified. Kept small and apart from the
// PainPal mark, so it never reads as Strava's endorsement.
export function PoweredByStrava() {
  return <img className={styles.mark} src={poweredByStrava} alt="Powered by Strava" height={12} />;
}
